import LegalPageLayout from "../components/LegalPageLayout";

const highlights = [
  "Cookies help the site remember preferences, understand traffic patterns and support essential technical functions.",
  "We use a limited set of cookies and similar technologies for performance, security and analytics purposes.",
  "You can control cookies through your browser settings, although disabling some cookies may affect site functionality.",
];

const sections = [
  {
    heading: "What Cookies Are",
    paragraphs: [
      "Cookies are small text files placed on your device when you visit a website. They help websites function properly, remember preferences and understand how visitors interact with pages over time. Similar technologies such as local storage or analytics tags may serve related purposes.",
      "Vissera uses cookies and similar tools in a measured way to support security, website performance and user experience.",
    ],
  },
  {
    heading: "How We Use Cookies",
    paragraphs: [
      "Some cookies are essential for core site functionality, such as maintaining session state, supporting navigation and protecting the website from abuse. Other cookies may help us understand page performance, measure engagement or improve how content is presented to visitors.",
      "Where analytics tools are used, they are intended to provide aggregate behavioural insight rather than to identify visitors personally unless you voluntarily submit information through a form.",
    ],
  },
  {
    heading: "Managing Cookie Preferences",
    paragraphs: [
      "Most web browsers allow you to review, block or delete cookies through browser settings. You may also be able to configure device-level privacy settings that affect cookie behaviour and similar tracking technologies.",
      "Please note that disabling essential cookies can affect the availability or performance of parts of the website, including forms, security checks and saved preferences.",
    ],
  },
  {
    heading: "Changes To This Policy",
    paragraphs: [
      "We may update this Cookie Policy from time to time to reflect operational, technical or legal changes. When updates are made, the revised version will be published on this page with a new effective date.",
      "If you have questions about how cookies are used on this website, please contact our team through the Contact page.",
    ],
  },
];

export default function CookiePolicy() {
  return (
    <LegalPageLayout
      eyebrow="COOKIE POLICY"
      title={<>How this site uses <span className="text-[#B8860B]">cookies</span> and similar tools</>}
      intro="This page explains what cookies are, why they are used on the website and how you can manage them through your browser or device settings."
      lastUpdated="June 14, 2026"
      highlights={highlights}
      sections={sections}
    />
  );
}
